import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Query } from 'react-apollo'
import { gql } from 'apollo-boost'

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Query query={USER_DATA}>
        {
            ({ data }) => {
                return (
                    <Route {...rest} render={props => (
                        data && data.token ?
                            <Component {...props} /> :
                            <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                    )} />
                )
            }
        }
    </Query>
)

const USER_DATA = gql`
    query userData {
        token @client
    }
`